import Vue from 'vue'
import Vuex from 'vuex'
//import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    authState: {
      token: localStorage.getItem('token-user') || '',
      loggedUser: JSON.parse(localStorage.getItem('logged-user')) || '',
      status: 'notlogged',
    },
    settings: {},
    process: JSON.parse(localStorage.getItem('process')) || {},
    control: JSON.parse(localStorage.getItem('control')) || {},
  },
  getters: {
    isAuthenticated: state => !!state.authState.token,
    authStatus: state => state.authState.status,
    loggedUser: state => state.authState.loggedUser,
    settings: state => state.settings,
    // currentControl: state => state.control,
  },
  mutations: {
    saveControl(state, control){
      localStorage.setItem('control',JSON.stringify(control));
      state.control = control
    },
    controlReset(state){
      localStorage.setItem('control','{}');
      Vue.set(state.control, {});
    },
    saveProcess(state, process){
      localStorage.setItem('process',JSON.stringify(process));
      state.process = process
    },
    processStepDone(state, stepDone){
      // marco el proceso que se indique como hecho.
      state.process.steps.forEach( step  => {
        if( step.step == stepDone ) {
          step.done = true
        }
      })
      // this.saveProcess(state.process)
      localStorage.setItem('process',JSON.stringify(state.process));
      // state.process = process
    },
    authSuccess(state, {token, loggedUser} ) {
      state.authState.status = 'logged';
      state.authState.token = token;
      state.authState.loggedUser = loggedUser;
      localStorage.setItem('logged-user', JSON.stringify(loggedUser));
    },
    logout(state) {
      state.authState.token = '';
      state.authState.loggedUser = {};
      state.authState.status = 'notlogged';
      localStorage.removeItem('token-user');
      localStorage.removeItem('logged-user');
    },
    storeSettings(state,settings){
      state.settings = settings;
    }
  },
  actions: {
    
  }
})